var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 256,
    fill: "#202428"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.981 398.872L235.952 90.9067C236.769 89.1349 238.542 88 240.493 88H270.65C272.593 88 274.359 89.1247 275.181 90.8844L419.003 398.865C419.468 399.86 418.742 401 417.644 401H345.997C345.415 401 344.885 400.663 344.639 400.136L256.937 212.699C256.578 211.931 255.485 211.931 255.126 212.699L167.424 400.136C167.178 400.663 166.648 401 166.066 401H95.3432C94.2488 401 93.5228 399.866 93.981 398.872Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.823 326.403C249.024 318.202 262.32 318.202 270.521 326.403L311.395 367.277L255.672 423L199.949 367.277L240.823 326.403Z",
    fill: "url(#paint0_linear_383_1696)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_1696",
    x1: 256.238,
    y1: 422.255,
    x2: 256.238,
    y2: 325.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0256FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0256FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1264CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAura);
export default __webpack_public_path__ + "static/media/aura.51aae3acd9a77073dede27c0528335de.svg";
export { ForwardRef as ReactComponent };